if (typeof netreviewsWidget03 === 'undefined') {
  netreviewsWidget03 = {
    create : function(){ return {
      widgetID : '',
      jQuery : null,
      starWidth : 34,
      widgetFullWidth : 475,
      widgetFullHeight : 186,
      widgetWidth : 0,
      note : 0,
      noteSur10: false,
      textNote : "",
      floorNote : 0,
      diffNote : 0,
      scale : 0,
      html : '<div id="#id#widget03av"><div id="#id#widget03avBackground"><img id="#id#widget03avImage" src="https://cl.avis-verifies.com/fr/widget4/widget03.png" /><div id="#id#widget03avStars01"></div><div id="#id#widget03avStars02"></div><div id="#id#widget03avStars03"></div><div id="#id#widget03avStars04"></div><div id="#id#widget03avStars05"></div><div id="#id#widget03avStars06"></div><div id="#id#widget03avRateWrap"><span id="#id#widget03avRate"></span>/<span id="#id#widget03avRateOver"></span></div></div></div>',
      background : {
        'position' : "relative",
        'width' : "475px",
        'height' : "186px",
      },
      star : {
        'position' : "absolute",
        'width' : "34px",
        'height' : "34px",
        'bottom' : "13px"
      },
      imageFull : '<img alt="orange star" style="width: 33px;height: 33px;max-width: 33px;max-height: 33px;" src="https://cl.avis-verifies.com/fr/widget4/etoile_orange_full.png" />',
      imageEmpty : '<img alt="black star" style="width: 33px;height: 33px;max-width: 33px;max-height: 33px;" src="https://cl.avis-verifies.com/fr/widget4/etoile_orange_empty.png" />',
      star01 : {
        'left' : "137px"
      },
      star02 : {
        'left' : "174px"
      },
      star03 : {
        'left' : "209px"
      },
      star04 : {
        'left' : "245px"
      },
      star05 : {
        'left' : "281px"
      },
      ratingCommunCss : {
        'position': "absolute",
        'font-family': "sans-serif",
        'color': "#000",
        'line-height': "1",
        'font-weight':'normal'
      },
      ratingCss :{
        'width': "123px",
        'height': "53px",
        'font-size': "55px",
        'bottom': "8px",
        'right': "20px"
      },
      ratingCss10 : {
        'width': "117px",
        'height': "41px",
        'font-size': "42px",
        'bottom': "8px",
        'right': "13px"
      },
      popupCSS : '@charset "UTF-8";body.AV_fancybox-active{overflow:hidden}body.AV_fancybox-iosfix{position:fixed;left:0;right:0}.AV_fancybox-is-hidden{position:absolute;top:-9999px;left:-9999px;visibility:hidden}.AV_fancybox-container{position:fixed;top:0;left:0;width:100%;height:100%;z-index:99992;-webkit-tap-highlight-color:transparent;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform:translateZ(0);transform:translateZ(0);font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif}.AV_fancybox-bg,.AV_fancybox-inner,.AV_fancybox-outer,.AV_fancybox-stage{position:absolute;top:0;right:0;bottom:0;left:0}.AV_fancybox-outer{overflow-y:auto;-webkit-overflow-scrolling:touch}.AV_fancybox-bg{background:#1e1e1e;opacity:0;transition-duration:inherit;transition-property:opacity;transition-timing-function:cubic-bezier(.47,0,.74,.71)}.AV_fancybox-is-open .AV_fancybox-bg{opacity:.87;transition-timing-function:cubic-bezier(.22,.61,.36,1)}.AV_fancybox-caption-wrap,.AV_fancybox-infobar,.AV_fancybox-toolbar{position:absolute;direction:ltr;z-index:99997;opacity:0;visibility:hidden;transition:opacity .25s,visibility 0s linear .25s;box-sizing:border-box}.AV_fancybox-show-caption .AV_fancybox-caption-wrap,.AV_fancybox-show-infobar .AV_fancybox-infobar,.AV_fancybox-show-toolbar .AV_fancybox-toolbar{opacity:1;visibility:visible;transition:opacity .25s,visibility 0s}.AV_fancybox-infobar{top:0;left:0;font-size:13px;padding:0 10px;height:44px;min-width:44px;line-height:44px;color:#ccc;text-align:center;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:subpixel-antialiased;mix-blend-mode:exclusion}.AV_fancybox-toolbar{top:0;right:0;margin:0;padding:0}.AV_fancybox-stage{overflow:hidden;direction:ltr;z-index:99994;-webkit-transform:translateZ(0)}.AV_fancybox-is-closing .AV_fancybox-stage{overflow:visible}.AV_fancybox-slide{position:absolute;top:0;left:0;width:100%;height:100%;margin:0;padding:0;overflow:auto;outline:none;white-space:normal;box-sizing:border-box;text-align:center;z-index:99994;-webkit-overflow-scrolling:touch;display:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition-property:opacity,-webkit-transform;transition-property:transform,opacity;transition-property:transform,opacity,-webkit-transform}.AV_fancybox-slide:before{content:"";display:inline-block;vertical-align:middle;height:100%;width:0}.AV_fancybox-is-sliding .AV_fancybox-slide,.AV_fancybox-slide--current,.AV_fancybox-slide--next,.AV_fancybox-slide--previous{display:block}.AV_fancybox-slide--image{overflow:visible}.AV_fancybox-slide--image:before{display:none}.AV_fancybox-slide--video .AV_fancybox-content,.AV_fancybox-slide--video iframe{background:#000}.AV_fancybox-slide--map .AV_fancybox-content,.AV_fancybox-slide--map iframe{background:#e5e3df}.AV_fancybox-slide--next{z-index:99995}.AV_fancybox-slide>*{display:inline-block;position:relative;padding:24px;margin:44px 0;border-width:0;vertical-align:middle;text-align:left;background-color:#fff;overflow:auto;box-sizing:border-box}.AV_fancybox-slide>base,.AV_fancybox-slide>link,.AV_fancybox-slide>meta,.AV_fancybox-slide>script,.AV_fancybox-slide>style,.AV_fancybox-slide>title{display:none}.AV_fancybox-slide .AV_fancybox-image-wrap{position:absolute;top:0;left:0;margin:0;padding:0;border:0;z-index:99995;background:transparent;cursor:default;overflow:visible;-webkit-transform-origin:top left;transform-origin:top left;background-size:100% 100%;background-repeat:no-repeat;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition-property:opacity,-webkit-transform;transition-property:transform,opacity;transition-property:transform,opacity,-webkit-transform}.AV_fancybox-can-zoomOut .AV_fancybox-image-wrap{cursor:zoom-out}.AV_fancybox-can-zoomIn .AV_fancybox-image-wrap{cursor:zoom-in}.AV_fancybox-can-drag .AV_fancybox-image-wrap{cursor:-webkit-grab;cursor:grab}.AV_fancybox-is-dragging .AV_fancybox-image-wrap{cursor:-webkit-grabbing;cursor:grabbing}.AV_fancybox-image,.AV_fancybox-spaceball{position:absolute;top:0;left:0;width:100%;height:100%;margin:0;padding:0;border:0;max-width:none;max-height:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.AV_fancybox-spaceball{z-index:1}.AV_fancybox-slide--iframe .AV_fancybox-content{padding:0;width:80%;height:80%;max-width:calc(100% - 100px);max-height:calc(100% - 88px);overflow:visible;background:#fff}.AV_fancybox-iframe{display:block;padding:0;border:0;height:100%}.AV_fancybox-error,.AV_fancybox-iframe{margin:0;width:100%;background:#fff}.AV_fancybox-error{padding:40px;max-width:380px;cursor:default}.AV_fancybox-error p{margin:0;padding:0;color:#444;font-size:16px;line-height:20px}.AV_fancybox-button{box-sizing:border-box;display:inline-block;vertical-align:top;width:44px;height:44px;margin:0;padding:10px;border:0;border-radius:0;background:rgba(30,30,30,.6);transition:color .3s ease;cursor:pointer;outline:none}.AV_fancybox-button,.AV_fancybox-button:link,.AV_fancybox-button:visited{color:#ccc}.AV_fancybox-button:focus,.AV_fancybox-button:hover{color:#fff; background:#F28E23 !important;}.AV_fancybox-button[disabled]{color:#ccc;cursor:default;opacity:.6}.AV_fancybox-button svg{display:block;position:relative;overflow:visible;shape-rendering:geometricPrecision}.AV_fancybox-button svg path{fill:currentColor;stroke:currentColor;stroke-linejoin:round;stroke-width:3}.AV_fancybox-button--share svg path{stroke-width:1}.AV_fancybox-button--pause svg path:nth-child(1),.AV_fancybox-button--play svg path:nth-child(2){display:none}.AV_fancybox-button--zoom svg path{fill:transparent}.AV_fancybox-navigation{display:none}.AV_fancybox-show-nav .AV_fancybox-navigation{display:block}.AV_fancybox-navigation button{position:absolute;top:50%;margin:-50px 0 0;z-index:99997;background:transparent;width:60px;height:100px;padding:17px}.AV_fancybox-navigation button:before{content:"";position:absolute;top:30px;right:10px;width:40px;height:40px;background:rgba(30,30,30,.6)}.AV_fancybox-navigation .AV_fancybox-button--arrow_left{left:0}.AV_fancybox-navigation .AV_fancybox-button--arrow_right{right:0}.AV_fancybox-close-small{position:absolute;top:0;right:0;width:40px;height:40px;padding:0;margin:0;border:0;border-radius:0;background:transparent;z-index:10;cursor:pointer}.AV_fancybox-close-small:after{content:"Ã—";position:absolute;top:5px;right:5px;width:30px;height:30px;font:22px/30px Arial,Helvetica Neue,Helvetica,sans-serif;color:#888;font-weight:300;text-align:center;border-radius:50%;border-width:0;background-color:transparent;transition:background-color .25s;box-sizing:border-box;z-index:2}.AV_fancybox-close-small:focus{outline:none}.AV_fancybox-close-small:focus:after{outline:1px dotted #888}.AV_fancybox-close-small:hover:after{color:#555;background:#eee}.AV_fancybox-slide--iframe .AV_fancybox-close-small,.AV_fancybox-slide--image .AV_fancybox-close-small{top:0;right:-40px}.AV_fancybox-slide--iframe .AV_fancybox-close-small:after,.AV_fancybox-slide--image .AV_fancybox-close-small:after{font-size:35px;color:#aaa}.AV_fancybox-slide--iframe .AV_fancybox-close-small:hover:after,.AV_fancybox-slide--image .AV_fancybox-close-small:hover:after{color:#fff;background:transparent}.AV_fancybox-is-scaling .AV_fancybox-close-small,.AV_fancybox-is-zoomable.AV_fancybox-can-drag .AV_fancybox-close-small{display:none}.AV_fancybox-caption-wrap{bottom:0;left:0;right:0;padding:60px 2vw 0;background:linear-gradient(180deg,transparent 0,rgba(0,0,0,.1) 20%,rgba(0,0,0,.2) 40%,rgba(0,0,0,.6) 80%,rgba(0,0,0,.8));pointer-events:none}.AV_fancybox-caption{padding:30px 0;border-top:1px solid hsla(0,0%,100%,.4);font-size:14px;color:#fff;line-height:20px;-webkit-text-size-adjust:none}.AV_fancybox-caption a,.AV_fancybox-caption button,.AV_fancybox-caption select{pointer-events:all;position:relative}.AV_fancybox-caption a{color:#fff;text-decoration:underline}.AV_fancybox-slide>.AV_fancybox-loading{border:6px solid hsla(0,0%,39%,.4);border-top:6px solid hsla(0,0%,100%,.6);border-radius:100%;height:50px;width:50px;-webkit-animation:a .8s infinite linear;animation:a .8s infinite linear;background:transparent;position:absolute;top:50%;left:50%;margin-top:-30px;margin-left:-30px;z-index:99999}@-webkit-keyframes a{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes a{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.AV_fancybox-animated{transition-timing-function:cubic-bezier(0,0,.25,1)}.AV_fancybox-fx-slide.AV_fancybox-slide--previous{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);opacity:0}.AV_fancybox-fx-slide.AV_fancybox-slide--next{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);opacity:0}.AV_fancybox-fx-slide.AV_fancybox-slide--current{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}.AV_fancybox-fx-fade.AV_fancybox-slide--next,.AV_fancybox-fx-fade.AV_fancybox-slide--previous{opacity:0;transition-timing-function:cubic-bezier(.19,1,.22,1)}.AV_fancybox-fx-fade.AV_fancybox-slide--current{opacity:1}.AV_fancybox-fx-zoom-in-out.AV_fancybox-slide--previous{-webkit-transform:scale3d(1.5,1.5,1.5);transform:scale3d(1.5,1.5,1.5);opacity:0}.AV_fancybox-fx-zoom-in-out.AV_fancybox-slide--next{-webkit-transform:scale3d(.5,.5,.5);transform:scale3d(.5,.5,.5);opacity:0}.AV_fancybox-fx-zoom-in-out.AV_fancybox-slide--current{-webkit-transform:scaleX(1);transform:scaleX(1);opacity:1}.AV_fancybox-fx-rotate.AV_fancybox-slide--previous{-webkit-transform:rotate(-1turn);transform:rotate(-1turn);opacity:0}.AV_fancybox-fx-rotate.AV_fancybox-slide--next{-webkit-transform:rotate(1turn);transform:rotate(1turn);opacity:0}.AV_fancybox-fx-rotate.AV_fancybox-slide--current{-webkit-transform:rotate(0deg);transform:rotate(0deg);opacity:1}.AV_fancybox-fx-circular.AV_fancybox-slide--previous{-webkit-transform:scale3d(0,0,0) translate3d(-100%,0,0);transform:scale3d(0,0,0) translate3d(-100%,0,0);opacity:0}.AV_fancybox-fx-circular.AV_fancybox-slide--next{-webkit-transform:scale3d(0,0,0) translate3d(100%,0,0);transform:scale3d(0,0,0) translate3d(100%,0,0);opacity:0}.AV_fancybox-fx-circular.AV_fancybox-slide--current{-webkit-transform:scaleX(1) translateZ(0);transform:scaleX(1) translateZ(0);opacity:1}.AV_fancybox-fx-tube.AV_fancybox-slide--previous{-webkit-transform:translate3d(-100%,0,0) scale(.1) skew(-10deg);transform:translate3d(-100%,0,0) scale(.1) skew(-10deg)}.AV_fancybox-fx-tube.AV_fancybox-slide--next{-webkit-transform:translate3d(100%,0,0) scale(.1) skew(10deg);transform:translate3d(100%,0,0) scale(.1) skew(10deg)}.AV_fancybox-fx-tube.AV_fancybox-slide--current{-webkit-transform:translateZ(0) scale(1);transform:translateZ(0) scale(1)}.AV_fancybox-share{padding:30px;border-radius:3px;background:#f4f4f4;max-width:90%;text-align:center}.AV_fancybox-share h1{color:#222;margin:0 0 20px;font-size:35px;font-weight:700}.AV_fancybox-share p{margin:0;padding:0}p.AV_fancybox-share__links{margin-right:-10px}.AV_fancybox-share__button{display:inline-block;text-decoration:none;margin:0 10px 10px 0;padding:0 15px;min-width:130px;border:0;border-radius:3px;background:#fff;white-space:nowrap;font-size:14px;font-weight:700;line-height:40px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#fff;transition:all .2s}.AV_fancybox-share__button:hover{text-decoration:none}.AV_fancybox-share__button--fb{background:#3b5998}.AV_fancybox-share__button--fb:hover{background:#344e86}.AV_fancybox-share__button--pt{background:#bd081d}.AV_fancybox-share__button--pt:hover{background:#aa0719}.AV_fancybox-share__button--tw{background:#1da1f2}.AV_fancybox-share__button--tw:hover{background:#0d95e8}.AV_fancybox-share__button svg{position:relative;top:-1px;width:25px;height:25px;margin-right:7px;vertical-align:middle}.AV_fancybox-share__button svg path{fill:#fff}.AV_fancybox-share__input{box-sizing:border-box;width:100%;margin:10px 0 0;padding:10px 15px;background:transparent;color:#5d5b5b;font-size:14px;outline:none;border:0;border-bottom:2px solid #d7d7d7}.AV_fancybox-thumbs{display:none;position:absolute;top:0;bottom:0;right:0;width:212px;margin:0;padding:2px 2px 4px;background:#fff;-webkit-tap-highlight-color:transparent;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar;box-sizing:border-box;z-index:99995}.AV_fancybox-thumbs-x{overflow-y:hidden;overflow-x:auto}.AV_fancybox-show-thumbs .AV_fancybox-thumbs{display:block}.AV_fancybox-show-thumbs .AV_fancybox-inner{right:212px}.AV_fancybox-thumbs>ul{list-style:none;position:absolute;position:relative;width:100%;height:100%;margin:0;padding:0;overflow-x:hidden;overflow-y:auto;font-size:0;white-space:nowrap}.AV_fancybox-thumbs-x>ul{overflow:hidden}.AV_fancybox-thumbs-y>ul::-webkit-scrollbar{width:7px}.AV_fancybox-thumbs-y>ul::-webkit-scrollbar-track{background:#fff;border-radius:10px;box-shadow:inset 0 0 6px rgba(0,0,0,.3)}.AV_fancybox-thumbs-y>ul::-webkit-scrollbar-thumb{background:#2a2a2a;border-radius:10px}.AV_fancybox-thumbs>ul>li{float:left;overflow:hidden;padding:0;margin:2px;width:100px;height:75px;max-width:calc(50% - 4px);max-height:calc(100% - 8px);position:relative;cursor:pointer;outline:none;-webkit-tap-highlight-color:transparent;-webkit-backface-visibility:hidden;backface-visibility:hidden;box-sizing:border-box}li.AV_fancybox-thumbs-loading{background:rgba(0,0,0,.1)}.AV_fancybox-thumbs>ul>li>img{position:absolute;top:0;left:0;max-width:none;max-height:none;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.AV_fancybox-thumbs>ul>li:before{content:"";position:absolute;top:0;right:0;bottom:0;left:0;border:4px solid #4ea7f9;z-index:99991;opacity:0;transition:all .2s cubic-bezier(.25,.46,.45,.94)}.AV_fancybox-thumbs>ul>li.AV_fancybox-thumbs-active:before{opacity:1}@media (max-width:800px){.AV_fancybox-thumbs{width:110px}.AV_fancybox-show-thumbs .AV_fancybox-inner{right:110px}.AV_fancybox-thumbs>ul>li{max-width:calc(100% - 10px)}}',
      popObject : function (pop) {
        return this[pop];
      },
      replaceAll : function(text,str1, str2, ignore) {
        return text.replace(new RegExp(str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g,"\\$&"),(ignore?"gi":"g")),(typeof(str2)=="string")?str2.replace(/\$/g,"$$$$"):str2);
      },
      isMobile : function() {
        try{ document.createEvent("TouchEvent"); return true; }
        catch(e){ return false; }
      },
      IESniff : function(){
        var undef,
          v = 3,
          div = document.createElement('div'),
          all = div.getElementsByTagName('i');

        while (
          div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
            all[0]
          );

        return v > 4 ? v : undef;

      },
      isIpad : function() {
        return (
          //Detect iPhone
          (navigator.platform.indexOf("iPhone") != -1) ||
          //Detect iPod
          (navigator.platform.indexOf("iPod") != -1)
        );
      },
      buildAll : function () {
        var $ = this.jQuery;
        // here loop on all meta
        $('.netreviewsWidget').each(function() {
          $(this).removeClass('netreviewsWidget');
          // now we call a js on server
          $.getScript($(this).data('jsurl'),function(){
            // do stuff , nothing for now
          });
        });

      },
      initRate : function(note) {
        // change to string
        this.textNote = ''+note;
        // js remove .0 , so test it and add it
        if (this.textNote.length == 1) {
          this.textNote = note.toFixed(1);
        }
        if (note > 5) {
          this.noteSur10 = true;
        }
        this.floorNote = Math.floor(note);
        this.diffNote = note - this.floorNote;
        // now divide by 2 , bcz we use only 5 stars
        if (note > 5) {
          var noteTmp = (note/2);
          noteTmp.toFixed(1);
          this.floorNote = Math.floor(noteTmp);
          this.diffNote = noteTmp - this.floorNote;
          this.diffNote = this.diffNote.toFixed(2);
        }
        return this;
      },
      selectorID : function(element) {
        return '#'+this.widgetID+element;
      },
      fixWidth : function(width){
        var string = width + '';
        if (string.indexOf("px") > -1) {
          var tmp = parseInt(width.replace('px', ''));
        }
        else {
          var tmp = parseInt(width);
        }
        return tmp;
      },
      calculScale : function (width) {
        var tmp = this.fixWidth(width);
        var scale = 0;
        scale = tmp/this.widgetFullWidth;
        return scale.toFixed(3);
      },
      fillEmptyStar : function (i){
        var $ = this.jQuery;
        var selector = this.selectorID('widget03avStars0'+i);
        var starPosition = this.popObject('star0'+i);
        var $element = $(selector);
        $element.html(this.imageEmpty);
        $element.css(starPosition);
      },
      fillFullStar : function (i){
        var $ = this.jQuery;
        var selector = this.selectorID('widget03avStars0'+i);
        var starPosition = this.popObject('star0'+i);
        var $element = $(selector);
        $element.html(this.imageFull);
        $element.css(starPosition);
      },
      calculWidth : function(note) {
        var tmp = note*this.starWidth;
        return tmp.toFixed(2);
      },
      generateWidget : function (widgetCSS){
        if (widgetCSS.width) {
          this.widgetWidth = widgetCSS.width;
          delete widgetCSS.width;
        }
        else {
          this.widgetWidth = '200px'
        }

        // scale position according to css position
        var horizontalPosition =  (widgetCSS.left)? '0%' : '100%';
        var verticalPosition =  (widgetCSS.top)? '0%' : '100%';
        widgetCSS['transform-origin'] = horizontalPosition+" "+verticalPosition+" 0px";
        widgetCSS['-ms-transform-origin'] = horizontalPosition+" "+verticalPosition;
        this.scale = (!this.widgetWidth)? 0.5 : this.calculScale(this.widgetWidth);
        widgetCSS['transform'] = "scale("+this.scale+")";
        widgetCSS['-ms-transform'] = "scale("+this.scale+")";
        this._generateWidget_(widgetCSS);
      },
      _generateWidget_ : function (widgetCSS) {
        var $ = this.jQuery;
        var addDimension = false;
        // add widget id num
        var html = this.replaceAll(this.html,"#id#",this.widgetID);
        // css pour la position widget
        var $tmp = $('<div>'+html+'</div>');
        var $widget03 = $tmp.children();
        // add widget to body
        // check if fixed or not
        if(widgetCSS.position && widgetCSS.position == 'fixed'){
          $('body').append($tmp);
          $widget03.css('z-index','99999');
          $('#'+this.widgetID).remove();
        }
        else {
          $('#'+this.widgetID).replaceWith($tmp);
          $tmp.css('display','inline-block');
          $tmp.css('position','relative');
          $widget03.css('position','absolute');
          addDimension = true;
        }

        $widget03.css(widgetCSS);


        $widget03.find(this.selectorID('widget03avBackground')).css(this.background);
        // for ie8,ie7
        if(this.IESniff() < 9){
          $widget03.css('zoom',this.scale);
          $widget03.css('width',this.widgetFullWidth);
          $widget03.css('height',this.widgetFullHeight);
        }
        // find the children div but not the text div .
        $widget03.find(this.selectorID('widget03avBackground')).find('div')
          .not(this.selectorID('widget03avRateWrap')).css(this.star);
        // star loop thingy
        for (var i=1;i<6;i++) {
          (i<= this.floorNote)? this.fillFullStar(i,$) : this.fillEmptyStar(i,$);
        }
        $widget03.find(this.selectorID('widget03avImage'))
          .attr('alt', this.floorNote + (this.floorNote > 1 ? ' stars' : ' star'));
        var $image6 = $(this.selectorID('widget03avStars06'));
        if (this.diffNote == 0) {
          // hide star 6 , as their is not decimal in the rating
          $image6.hide();
        }
        else {
          $image6.html(this.imageFull);
          // postion de la note
          var posNote = this.floorNote + 1;
          var cssPourcentage = this.popObject('star0'+posNote);
          $image6.css(cssPourcentage);
          var width = this.calculWidth(this.diffNote);
          $image6.css('width',width+'px');
          $image6.css('overflow','hidden');
        }

        // text code
        var $rateWrap = $widget03.find(this.selectorID('widget03avBackground')).find(this.selectorID('widget03avRateWrap'));
        $rateWrap.css(this.ratingCommunCss);
        $rateWrap.find('span').css('font-size','inherit');
        $rateWrap.find(this.selectorID('widget03avRate')).html(this.textNote);
        if(this.noteSur10){
          $rateWrap.css(this.ratingCss10);
          $rateWrap.find(this.selectorID('widget03avRateOver')).html('10');
        }
        else {
          $rateWrap.css(this.ratingCss);
          $rateWrap.find(this.selectorID('widget03avRateOver')).html('5');
        }

        if (addDimension) {
          var dimensions = $widget03[0].getBoundingClientRect();
          $tmp.height(dimensions.height);
          $tmp.width(dimensions.width);
        }

      },
      addIframe : function (src){
        var $ = this.jQuery;
        // dont create pop if allready created.
        $('body').append('<style>'+this.popupCSS+'</style>')
        var $widget03 = $(this.selectorID('widget03av'));
        $widget03.css('cursor','pointer');

        $widget03.click(function(){
          // FANCYBOX V3
          $.fancybox.open({
            src : src,
            type : 'iframe',
            opts : defaults,
            iframe : {
              css : {
                width : '820px'
              }
            }
          });
        });

      },
      newTabLink : function(src){
        var $ = this.jQuery;
        var $widget03 = $(this.selectorID('widget03av'));
        $widget03.css('cursor','pointer');
        $widget03.click(function(){
          window.open(src);
        });
      },
      mobileConfig : function(config){
        var $ = this.jQuery;
        var $widget03 = $(this.selectorID('widget03av'));
        var mobileWidth = this.fixWidth(config.mobileWidth);
        if ($(window).width() < mobileWidth) {
          var scale = this.calculScale(config.width);
          $widget03.css('transform',"scale("+scale+")");
          var av = document.getElementById('avisverifieswidgetlistcontent');
          if(av == null){
            if (config.hideWidget) {
              $widget03.hide();
            }
          }
        }
      },
      customConfig : function(widthCustom1,widthCustom2, type){
        var $ = this.jQuery;
        var av = document.getElementById('avisverifieswidgetlistcontent');
        if(av == null){
          var $widget03 = $(this.selectorID('widget03av'));
          if(parseInt(type) == 0 && $(window).width() < parseInt(widthCustom1) ){
            $widget03.hide();
          }
          else if(parseInt(type) == 500 && $(window).width() > parseInt(widthCustom1) ){
            $widget03.hide();
          }
          else if(parseInt(type) == 800)
          {
            if(parseInt(widthCustom2) > parseInt(widthCustom1)){
              if ($(window).width() < parseInt(widthCustom1) ||  parseInt(widthCustom2) < $(window).width() ) {
                $widget03.hide();
              }
            }
            else if(parseInt(widthCustom2) < parseInt(widthCustom1)){
              if ($(window).width() < parseInt(widthCustom2) ||  parseInt(widthCustom1) < $(window).width() ) {
                $widget03.hide();
              }
            }
          }
        }
      },
      widgetTrack : function(src) {
        var $ = this.jQuery;
        var $widget03 = $(this.selectorID('widget03av'));
        $widget03.mouseenter(function() {
          var $this = $(this);
          var widgetHover = $this.attr('widgetHover');
          if (widgetHover != 'yes') {
            $('body').append("<img src='"+src+"'  width='1' height='1' style='position:fixed;bottom:0;left0;' />");
            $this.attr('widgetHover','yes');
          }
        });
      }
    };
    }
  };
  netreviewsWidget03Main = netreviewsWidget03.create();
  netreviewsWidget03Main.jQuery = jQuery;
  netreviewsWidget03Main.jQuery(document).ready(function(){
    netreviewsWidget03Main.buildAll();
  });
}
